<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">学员信息</li>
      </ul>
    </div>
    <div class="member-main-body">
      <!-- <div class="no-data" v-show="dataList.length <= 0">
        <img src="../../assets/images/v3/no-data.png" />
        <p>暂无学员信息</p>
      </div> -->
      <div class="student-body clearfix">
        <div class="table-tr">
          <div class="table-th">姓名</div>
          <div class="table-td">{{ dataInfo.StudentName }}</div>
        </div>
        <div class="table-tr">
          <div class="table-th">性别</div>
          <div class="table-td">{{ dataInfo.Sex }}</div>
        </div>
        <div class="table-tr">
          <div class="table-th">身份证号</div>
          <div class="table-td">{{ dataInfo.idCardNo }}</div>
        </div>
        <div class="table-tr">
          <div class="table-th">专业名称</div>
          <div class="table-td">{{ dataInfo.MajorName }}</div>
        </div>
        <div class="table-tr">
          <div class="table-th">专业层次</div>
          <div class="table-td">{{ dataInfo.levelName }}</div>
        </div>
        <div class="table-tr">
          <div class="table-th"></div>
          <div class="table-td"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { custom } from "../../request/index";
export default {
  mixins: [siteMixin],
  data() {
    return {
      dataInfo: {},
    };
  },
  watch: {
    srfId(newId) {
      this.getData();
    },
  },
  mounted() {
    this.setMetaData("学员信息");
    this.getData();
  },
  methods: {
    getData() {
      if (!this.srfId) return;
      custom.getSrfInfo(this.srfId).then((res) => {
        console.log("srfInfo", res);
        if (res.status === 1) {
          this.dataInfo = res.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var";
@import "../../assets/css/member-main.less";
.member-main-body {
  padding: 24px;
}
.student-body {
  border-radius: 6px;
  border: 1px solid #ccc;
  overflow: hidden;
  //   margin: 10px auto;
  // display: flex;
  // flex-wrap: wrap;

  .table-tr {
    float: left;
    width: 50%;
    height: 37px;
    display: flex;
    // &:nth-child(4n + 3) {
    //   background-color: #d5f0ff;
    // }
    // &:nth-child(4n) {
    //   background-color: #d5f0ff;
    // }
    .table-th {
      margin: -1px 0 0 -1px;
      padding: 8px 10px;
      width: 30%;
      font-weight: bold;
      border-left: 1px solid #ccc;
      border-top: 1px solid #ccc;
      display: flex;
      align-items: center;
      .ellipsis();
    }
    .table-td {
      margin: -1px 0 0 -1px;
      padding: 8px 10px;
      flex: 1;
      border-left: 1px solid #ccc;
      border-top: 1px solid #ccc;
      .ellipsis();
    }
  }
}
</style>